import { inject } from 'mobx-react';
import * as React from 'react';
import { RouteComponentProps } from '../../../node_modules/@types/react-router';
import { OnboardingCreateStoryConstants as ui } from '../../Config/UIConstants';
import { CommonActionButton } from '../../SharedComponents/CommonActionButton';
import { Tab } from '../../SharedComponents/CommonTabbedContainer';
import { FullScreenModalContainer } from '../../SharedComponents/FullScreenModalContainer';
import { StoryTitleField } from '../../SharedComponents/StoryTitleField';
import { Routes } from '../../_controllers/RouteController';
import { ApplicationStore } from '../../_stores/ApplicationStore';
import { colors } from '../../styles/colors';
import { largeShadow } from '../../styles/styleObjects';
import { OnboardingActivityIndicator, OnboardingPages } from './OnBoardingNav';
import { onboardingStyles } from './OnboardingStyles';

interface IState {
    activeTab: Tab;
    shouldCheckInputs: boolean;
    storyName: string;
}

interface IProps {
    store: ApplicationStore;
}

@inject('store')
export class OnboardingCreateStory extends React.Component<RouteComponentProps<any> & IProps> {
    //TODO: We should set a warning if you try to navigate away from this page, the signup information will be lost.

    public state: IState = {
        activeTab: Tab.LEFT,
        shouldCheckInputs: false,
        storyName: '',
    };

    private onPressAddNow = (): void => {
        this.setState({ shouldCheckInputs: true }, () => {
            if (this.state.storyName.trim() !== '') {
                this.props.store.onboardingStore.setStoryInformation(
                    this.state.storyName,
                    this.state.activeTab === Tab.LEFT,
                );

                this.props.history.push(Routes.ONBOARDING_ADD_PHOTOS);
            }
        });
    }

    private onPressAddLater = (): void => {
        this.setState({ shouldCheckInputs: true }, () => {
            if (this.state.storyName.trim() !== '') {
                this.props.store.onboardingStore.setStoryInformation(
                    this.state.storyName,
                    this.state.activeTab === Tab.LEFT,
                );

                this.props.history.push(Routes.ONBOARDING_CREATE_FAMILY);
            }
        });
    }

    public render() {
        return (
            <FullScreenModalContainer
                justifyContent="space-between"
                alignItems="center"
                {...this.props}
                onPressExit={() => this.props.history.push(Routes.ALBUMS)}
            >
                <div style={styles.contentContainer}>
                    <p style={onboardingStyles.headerText}>
                        Create a story album
                    </p>
                    <p style={styles.topSubHeader}>
                        Every photo needs a home to start the storytelling. We call this a story album. So go ahead and
                        create one now.
                    </p>
                    <div>
                        <StoryTitleField
                            updateValue={title => {
                                this.setState({ storyName: title });
                            }}
                            value={this.state.storyName}
                        />
                    </div>
                    <p style={styles.topSubHeader}>
                        A good title helps identify an album’s subject matter (e.g., “1972 Family Reunion” or “2006
                        Roger and June’s Wedding”). Add your own title now or accept the default. It’s easy to change
                        the title later.
                    </p>
                    <p style={styles.topSubHeader}>
                        There’s no limit to the number of story albums you can create!
                    </p>
                </div>
                <div style={styles.bottomContainer}>
                    <div style={styles.flexRow}>
                        <CommonActionButton
                            buttonContent={ui.SKIP_ADD_LATER}
                            containerStyle={{ ...styles.buttonContainer, backgroundColor: colors.CANCEL_TEXT }}
                            fontStyle={styles.buttonText}
                            onClick={this.onPressAddLater}
                            isDisabled={false}
                        />
                        <div style={styles.spacer} />
                        <CommonActionButton
                            buttonContent={ui.ADD_PHOTOS_NOW}
                            containerStyle={styles.buttonContainer}
                            fontStyle={styles.buttonText}
                            onClick={this.onPressAddNow}
                            isDisabled={this.state.storyName === ''}
                        />
                    </div>

                    <OnboardingActivityIndicator activePage={OnboardingPages.CreateStory}/>
                </div>
            </FullScreenModalContainer>
        );
    }
}

const styles = {
    spacer: { width: 20 },
    flexRow: {
        display: 'flex',
        flexDirection: 'row',
    } as React.CSSProperties,
    storyNameWarningText: {
        marginBottom: -10,
        marginTop: 5,
    },
    rightTabText: {
        color: 'black',
        paddingTop: 3,
        marginLeft: 8,
        textAlign: 'center',
        width: '100%',
    },
    rightTabContainer: {
        width: '100%',
        backgroundColor: 'white',
        height: 50,
        display: 'flex',
        alignItems: 'center',
    } as React.CSSProperties,
    lockText: {
        color: 'black',
        paddingTop: 3,
        marginLeft: 8,
    },
    lockImage: {
        marginLeft: 15,
        height: 15,
        width: 15,
        objectFit: 'contain',
    },
    leftTabContainer: {
        width: '100%',
        backgroundColor: 'white',
        height: 50,
        display: 'flex',
        alignItems: 'center',
    } as React.CSSProperties,
    bottomSubHeader: {
        width: '100%',
        textAlign: 'center',
        fontSize: 18,
        opacity: 0.8,
        marginTop: 10,
        marginBottom: 20,
    },
    midSubHeader: {
        fontSize: 22,
        marginTop: 30,
        color: 'black',
        fontWeight: 900,
        textAlign: 'center',
    } as React.CSSProperties,
    topSubHeader: {
        width: '100%',
        textAlign: 'center',
        fontSize: 16,
        opacity: 0.8,
        marginTop: 15,
    } as React.CSSProperties,
    inputContainer: {
        width: '100%',
        height: 85,
        marginBottom: 15,
        backgroundColor: 'white',
        boxShadow: largeShadow,
        marginTop: 20,
    },
    contentContainer: {
        display: 'flex',
        width: 450,
        height: '50%',
        flexDirection: 'column',
        flex: 1,
        justifyContent: 'center',
    } as React.CSSProperties,
    bottomContainer: {
        height: 150,
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
    } as React.CSSProperties,
    buttonText: {
        fontSize: 14,
        fontWeight: 200,
        letterSpacing: 1,
    } as React.CSSProperties,
    buttonContainer: {
        height: 48,
        width: 220,
    },
};



// WEBPACK FOOTER //
// ./src/Pages/OnboardingPages/OnboardingCreateStory.tsx